import { JsonObject, JsonProperty } from 'json2typescript';
import { SheduledReportsGenerateInterface } from '../interfaces/scheduledreportsgenerated.interface';

@JsonObject('SheduledReportsGenerateModel')
export class SheduledReportsGenerateModel implements SheduledReportsGenerateInterface {
  Date?: string;
  Scheduledreportid?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
